module.exports = __webpack_public_path__ + "img/pic_australia_04.03e7fe3f.jpg";